(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('paymentMethod', paymentMethod);

    /* @ngInject */
    function paymentMethod() {
        var directive = {
            bindToController: true,
            templateUrl: "payment-method.tpl",
            controller: paymentMethodCtrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                // id: '<',
                field: '=',
                fieldModel: '=ngModel'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            // && navigator.userAgent.indexOf('Firefox') == - 1



            scope.vm.wallet = navigator.userAgent  && (
            navigator.userAgent.indexOf('iPhone') != -1 ||
            (
                navigator.userAgent.indexOf('Macintosh') != -1 &&
                navigator.userAgent.indexOf('Chrome') == -1 &&
                navigator.userAgent.indexOf("Safari") != -1
                // navigator.vendor.indexOf('Apple') > -1 ,
                // navigator.userAgent.indexOf('Safari') != -1 &&
                // navigator.userAgent.indexOf('Macintosh') != -1 &&
                // navigator.userAgent.indexOf('CriOS') == -1 &&
                // navigator.userAgent.indexOf('FxiOS') == -1
            )
            ) ? 'apple' : 'google';

            console.log('WALLET',navigator.userAgent, scope.vm.wallet);
            //window.detectWallet = true;
        }
    }
    /* @ngInject */
    function paymentMethodCtrl($scope) {
        $scope.methodImg = function(m) {
            var url = $scope.vm.field.images.card;
            if (m == 'wallet') {
                url = $scope.vm.field.images[$scope.vm.wallet];
            }
            return url;
        };

        window.walletOk = function(wallet) {
            // console.log("walletOk", wallet);
            if (wallet !== false) {
                $scope.$apply(function() {
                    $scope.vm.wallet = wallet;
                });
            } else {
                console.log(false);
                $scope.fieldModel.value = 'card';
            }
        };
    }
})();